import React from "react";
import { useTranslation } from "react-i18next";

const FAQ = () => {
  const { t } = useTranslation();

  const faqs = [
    {
      q: t("How long does it take to set up Hisabak?"),
      a: t("Under 10 minutes. Sign up, add a few products (Excel import or our 500K-item Egyptian catalogue), connect any thermal printer over Bluetooth, and start selling. No technician visit needed."),
    },
    {
      q: t("Does Hisabak support Arabic?"),
      a: t("Yes - Hisabak is Arabic-first with full RTL support, Arabic receipts, Arabic product names and Arabic dashboards. English is available too. You can switch language anytime from settings."),
    },
    {
      q: t("Is Hisabak compliant with the Egypt e-invoice system?"),
      a: t("Yes. Hisabak supports Egyptian Tax Authority (ETA) e-invoice and e-receipt requirements out of the box, so you can stay compliant without extra software."),
    },
    {
      q: t("What hardware do I need?"),
      a: t("Just an Android phone, tablet, iPhone, iPad or Windows PC. Optional: a thermal Bluetooth printer (we sell starter kits at cost), a barcode scanner and a cash drawer. Nothing else."),
    },
    {
      q: t("Can I run multiple branches on one account?"),
      a: t("Yes. Track inventory, staff and sales across unlimited branches from a single dashboard. Stock transfers between branches are one-click."),
    },
    {
      q: t("How much does Hisabak cost?"),
      a: t("Starter is free forever. Growth plan is EGP 299/month (or 20% off annually) and Chain plan is EGP 799/month. There are no setup fees, no contracts, and you can cancel anytime."),
    },
   {
  q: (
    <>
      {t("Do you accept mobile wallets like InstaPay, Vodafone Cash and Fawry?")
        .split("InstaPay")[0]}

      {t("InstaPay")}

      {t("Do you accept mobile wallets like InstaPay, Vodafone Cash and Fawry?")
        .split("InstaPay")[1]
        .split("Vodafone Cash")[0]}

      {t("Vodafone Cash")}

      {t("Do you accept mobile wallets like InstaPay, Vodafone Cash and Fawry?")
        .split("Vodafone Cash")[1]
        .split("Fawry")[0]}

      {t("Fawry")}

      {t("Do you accept mobile wallets like InstaPay, Vodafone Cash and Fawry?")
        .split("Fawry")[1]}
    </>
  ),

  a: (
    <>
      {t(
        "Yes. Hisabak supports cash, card, InstaPay, Vodafone Cash, Fawry and split payments. Customers can also receive their receipt via WhatsApp."
      )
        .split("InstaPay")[0]}

      {t("InstaPay")}

      {t(
        "Yes. Hisabak supports cash, card, InstaPay, Vodafone Cash, Fawry and split payments. Customers can also receive their receipt via WhatsApp."
      )
        .split("InstaPay")[1]
        .split("Vodafone Cash")[0]}

      {t("Vodafone Cash")}

      {t(
        "Yes. Hisabak supports cash, card, InstaPay, Vodafone Cash, Fawry and split payments. Customers can also receive their receipt via WhatsApp."
      )
        .split("Vodafone Cash")[1]
        .split("Fawry")[0]}

      {t("Fawry")}

      {t(
        "Yes. Hisabak supports cash, card, InstaPay, Vodafone Cash, Fawry and split payments. Customers can also receive their receipt via WhatsApp."
      )
        .split("Fawry")[1]}
    </>
  ),
},
    {
      q: t("What kind of support do you offer?"),
      a: t("Free WhatsApp + phone support 6 days a week (9 AM-9 PM EET). Growth and Chain plans get priority support and a dedicated success manager."),
    },
    {
      q: t("Can I import my existing products and customers?"),
      a: t("Yes - bulk import via Excel/CSV, or our team will migrate everything for free if you're switching from another system."),
    },
  ];

  return (
    <section id="faqs" className="py-8 md:py-16 scroll-mt-24">
      <div className="container mx-auto px-4">
        {/* Section Head */}
        <div className="mx-auto mb-6 max-w-3xl text-center">
         
          <h2 className="mb-3 text-[clamp(28px,3.6vw,44px)] font-black leading-[1.12] tracking-normal text-gray-900">
            {t("Everything you need to know")}
          </h2>
          <p className="text-[17px] leading-relaxed text-gray-500">
            {t("Still unsure? Chat with us on WhatsApp - we usually reply within 5 minutes.")}
          </p>
        </div>

        {/* FAQ List */}
        <div className="mx-auto max-w-3xl space-y-3">
          {faqs.map((item, index) => (
            <details
              key={index}
              className={`group rounded-xl border bg-white transition ${
                item.open ? "border-blue-600" : "border-gray-200"
              }`}
              open={item.open}
            >
              <summary className="flex cursor-pointer list-none items-center justify-between px-6 py-5 font-semibold text-gray-900">
                {item.q}
                <span className="text-2xl font-light text-blue-600 transition group-open:rotate-45">
                  +
                </span>
              </summary>
              <div className="px-6 pb-5 text-[15px] leading-7 text-gray-600">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;